export default __webpack_public_path__ + "img/empty-chart.0ffb63c4.svg";